import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component( {
    selector: 'app-warning-dialog',
    templateUrl: './warning-dialog.component.html',
    styleUrls: ['./warning-dialog.component.scss']
} )
export class WarningDialogComponent implements OnInit {

    constructor( @Inject( MAT_DIALOG_DATA ) public data,
        public dialogRef: MatDialogRef<WarningDialogComponent> ) { }

    ngOnInit() {
    }

    closeDialog() {
        this.dialogRef.close( false );
    }
}
